import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { MATHtest } from '../../../../assets/js/fullscreen';
import { QuestionAddEditComponent } from '../question-add-edit/question-add-edit.component';
import {
  IFlashcard,
  ISubject,
} from '../question-add-edit/interface/falshcard.interface';
import { AddEditFlashManagementService } from '../question-add-edit/services/add-edit.flash-management.service';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';

declare var DataTable: any;

enum ListType {
  LIST = 'list',
  HISTORY = 'history',
}
@Component({
  selector: 'app-fa-question-list',
  templateUrl: './question-list.component.html',
  styleUrls: ['./question-list.component.css'],
})
export class QuestionListComponent implements OnInit {
  @Input() subjectById: ISubject;
  @Output() openSelectedFlashCard = new EventEmitter();
  @Input() type: string;
  public flashCardList: Array<IFlashcard> = [];

  ngOnInit(): void {
    console.log(location.href);

    const lastIndex = decodeURIComponent(
      (new URL(location.href).pathname || '').split('/').pop() || ''
    );

    let status: string | null = '';

    if (lastIndex === 'SUBJECT BREAKDOWN') {
      status = null;
    } else {
      status = lastIndex;
    }

    if (this.type === 'list') {
      this.addEditFlashManagementService
        .getFlashcards({
          LoggedInUser: UserAuthDetails.getUserLoggedInId(),
          SessionLanguageTypeCode: null,
          SubjectID:
            typeof this.subjectById === 'number' ||
            typeof this.subjectById === 'string'
              ? +(this.subjectById as number)
              : this.subjectById.Subject_Id,
          FlashCardID: null,
          FromDate: null,
          ToDate: null,
          FlashCardStatus: status,
          FlashCardKeyword1: null,
          Operator: null,
          FlashCardKeyword2: null,
          OwnFlashCardInd: null,
          ScreenName:'ASSIGN_FLASHCARD_TO_COURSE'
        })
        .subscribe((elem:any) => {
          this.flashCardList = [...elem.result];
          // this.flashCardIdMatched = elem.FlashCard_ID;
          // this.NextButtonflag = true;
          setTimeout(() => {
            new DataTable('#example', {
              pageLength: 25,
            });

            ['fst', 'bst'].forEach((elem) => {
              const el = document.querySelector('#' + elem);

              if (el) {
                el.classList.remove('sorting');
              }
            });
          });
        });
    } else if (this.type === 'history') {
      this.addEditFlashManagementService
        .getFlashcardsActivityHistory({
          LoggedInUser: UserAuthDetails.getUserLoggedInId(),
          SessionLanguageTypeCode: null,
          SubjectID:
            typeof this.subjectById === 'number' ||
            typeof this.subjectById === 'string'
              ? +(this.subjectById as number)
              : this.subjectById.Subject_Id,
          FlashCardID: null,
          FromDate: null,
          ToDate: null,
          FlashCardStatus: status,
          FlashCardKeyword1: null,
          Operator: null,
          FlashCardKeyword2: null,
          OwnFlashCardInd: null,
          ScreenName:'ASSIGN_FLASHCARD_TO_COURSE'
        })
        .subscribe((elem:any ) => {
          console.log(elem);
          
          this.flashCardList = elem?.FlashCardActivityHistory;
          // this.flashCardIdMatched = elem.FlashCard_ID;
          // this.NextButtonflag = true;
          setTimeout(() => {
            const j = new DataTable('#example', {
              pageLength: 25,
            });

            ['fst', 'bst'].forEach((elem) => {
              const el = document.querySelector('#' + elem);

              if (el) {
                el.classList.remove('sorting');
              }
            });
          });
        });
    }
  }

  constructor(
    private readonly addEditFlashManagementService: AddEditFlashManagementService,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  openFlashcard(flashCard: IFlashcard) {
    this.openSelectedFlashCard.emit({
      FlashCard_ID: flashCard.FlashCard_ID,
      type: this.type,
      FlashcardList: this.flashCardList,
    });
  }

  stopProp(event: Event) {
    event.stopPropagation();
    return false;
  }
}
